import { css } from 'styled-components';

export type TAlignmentHorizontal =
    | 'left'
    | 'center'
    | 'right'
    | 'start'
    | 'end';

export function getAlignment(alignment: TAlignmentHorizontal) {
    let justify: string;
    let align: string;

    switch (alignment) {
        case 'left':
        case 'start':
            justify = 'flex-start';
            align = 'start';
            break;
        case 'center':
            justify = 'center';
            align = 'center';
            break;
        case 'right':
        case 'end':
            justify = 'flex-end';
            align = 'end';
            break;
        default:
            return null;
    }

    return css`
        justify-content: ${justify};
        text-align: ${align};
    `;
}
